import {
  TotpTokenRequestParams,
  TotpTransferParams,
  ValidationType,
} from '@portal/models/enumerators/totp';
import TotpApi from '@portal/repositories/totp';
import * as ActionTypes from './actionTypes';
import { decreaseLoading, increaseLoading } from './loading';
import * as MessageService from '~/services/message';

export const setValidationTypeTotp = (type: ValidationType) => ({
  payload: type,
  type: ActionTypes.SET_TOTP_TYPE_VALIDATION,
});

export const unsetSuccessTotp = () => ({
  payload: null,
  type: ActionTypes.SET_SUCCESS_PIN_FOR_TOTP,
});

export const unsetErrorTotp = () => ({
  payload: {
    error: null,
  },
  type: ActionTypes.SET_ERROR_PIN_FOR_TOTP,
});

export const requestTotpToken =
  (params: TotpTokenRequestParams) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      await TotpApi.requestToken(params);
      dispatch({
        type: ActionTypes.SEND_TOTP_FOR_USER,
        payload: true,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const totpTransfer =
  (params: TotpTransferParams) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const transaction = await TotpApi.totpTransfer(params);
      if (transaction) {
        dispatch({
          type: ActionTypes.SET_DETAILS,
          payload: transaction,
        });
      }
      dispatch({
        type: ActionTypes.SET_SUCCESS_PIN_FOR_TOTP,
        payload: true,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SET_ERROR_PIN_FOR_TOTP,
        payload: {
          error,
        },
      });
    } finally {
      dispatch(decreaseLoading());
    }
  };
